export default "__VITE_ASSET__2ae36fcf__"